import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgReduxModule } from '@angular-redux/store';
import { NgRedux, DevToolsExtension } from '@angular-redux/store';
import { rootReducer, ArchitectUIState } from './ThemeOptions/store';
import { ConfigActions } from './ThemeOptions/store/config.actions';
import { AppRoutingModule } from './app-routing.module';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';
import { CommonModule } from '@angular/common';
import { AppComponent } from './app.component';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

// BOOTSTRAP COMPONENTS

import { AngularFontAwesomeModule } from 'angular-font-awesome';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';

// LAYOUT

import { BaseLayoutComponent } from './Layout/base-layout/base-layout.component';
import { PagesLayoutComponent } from './Layout/pages-layout/pages-layout.component';
import { PageTitleComponent } from './Layout/Components/page-title/page-title.component';

// HEADER

import { HeaderComponent } from './Layout/Components/header/header.component';
import { SearchBoxComponent } from './Layout/Components/header/elements/search-box/search-box.component';
import { UserBoxComponent } from './Layout/Components/header/elements/user-box/user-box.component';

// SIDEBAR

import { SidebarComponent } from './Layout/Components/sidebar/sidebar.component';


// FOOTER

import { FooterComponent } from './Layout/Components/footer/footer.component';

// DEMO PAGES

// Dashboards

import { Home } from './Pages/home/home.component';

// Pages

import { ForgotPasswordBoxedComponent } from './Pages/forgot-password/forgot-password.component';
import { LoginBoxedComponent } from './Pages/login/login.component';
import { RegisterBoxedComponent } from './Pages/register/register.component';

// Elements

import { FileComplainComponent } from './Portal/file-complain/file-complain.component';

// Components
import { EmergencyComponent } from './Portal/emergency-number/emergency.component';

// Tables

import { RegularComponent } from './Portal/my-complains/my-complains.component';

// loader
import { NgxSpinnerModule, NgxSpinnerService } from "ngx-spinner";

// Widgets


// Forms Elements

import { ResourceComponent } from './Portal/resource-center/resource.component';


import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { AuthInterceptor } from './Pages/http-interceptors/auth-interceptor';
import { ComplainDetailComponent } from './Portal/complain-detail/complain-detail.component';
import { S3Service } from './Portal/file-complain/s3.service';
import { DlDateTimeDateModule, DlDateTimePickerModule } from 'angular-bootstrap-datetimepicker';
import { MomentTimezoneModule } from 'angular-moment-timezone';
import { ToastrModule } from 'ngx-toastr';
import { BlockUIModule } from 'ng-block-ui';
import { ProfileComponent } from './Portal/profile/profile.component';
import { CategoriesResourceComponent } from './Portal/resource-center/categoriesResourceCenter/categoriesResource.component';
import { FilterPipe } from './Portal/emergency-number/filter.pipe';
import { NumberDirective } from './Directives/only-number.directive';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true
};

@NgModule({
  declarations: [
    FilterPipe,
    // LAYOUT

    AppComponent,
    BaseLayoutComponent,
    PagesLayoutComponent,
    PageTitleComponent,

    // HEADER

    HeaderComponent,
    SearchBoxComponent,
    UserBoxComponent,

    // SIDEBAR

    SidebarComponent,


    // FOOTER

    FooterComponent,

    // DEMO PAGES

    // Dashboards

    Home,

    // User Pages

    ForgotPasswordBoxedComponent,
    LoginBoxedComponent,
    RegisterBoxedComponent,

    // Elements

    FileComplainComponent,
    ComplainDetailComponent,
    CategoriesResourceComponent,


    // Components
    EmergencyComponent,


    // Tables

    RegularComponent,


    // Dashboard Boxes



    // Form Elements

    ResourceComponent,
    ProfileComponent,
    
    // Custom Directives
    NumberDirective,


  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    NgReduxModule,
    CommonModule,
    LoadingBarRouterModule,

    // Angular Bootstrap Components

    PerfectScrollbarModule,
    NgbModule,
    AngularFontAwesomeModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    // Charts
    BlockUIModule.forRoot(),
    DlDateTimeDateModule,
    DlDateTimePickerModule,
    MomentTimezoneModule,
    NgxSpinnerModule,
    ToastrModule.forRoot({

      timeOut: 1000,
      // positionClass: 'toast-bottom-right',
      preventDuplicates: true,
    })
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    {
      provide:
        PERFECT_SCROLLBAR_CONFIG,
      // DROPZONE_CONFIG,
      useValue:
        DEFAULT_PERFECT_SCROLLBAR_CONFIG,
      // DEFAULT_DROPZONE_CONFIG,
    },
    ConfigActions,
    S3Service,
    NgxSpinnerService
  ],
  bootstrap: [AppComponent]
})

export class AppModule {
  constructor(private ngRedux: NgRedux<ArchitectUIState>,
    private devTool: DevToolsExtension) {

    this.ngRedux.configureStore(
      rootReducer,
      {} as ArchitectUIState,
      [],
      [devTool.isEnabled() ? devTool.enhancer() : f => f]
    );

  }
}
